import { render, staticRenderFns } from "./AtomTitle.vue?vue&type=template&id=10fc3bfa&scoped=true&"
import script from "./AtomTitle.vue?vue&type=script&lang=js&"
export * from "./AtomTitle.vue?vue&type=script&lang=js&"
import style0 from "./AtomTitle.vue?vue&type=style&index=0&id=10fc3bfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc3bfa",
  null
  
)

export default component.exports